import DepartmentModal from './DepartmentModal';

export default (props) => {
  return <DepartmentModal {...props} />;
};
